import React, { useContext, useEffect } from 'react';
import { Context } from '../../../context/global-data-provider';
import { PostsListContext } from '../../../context/category-posts-list-provider';
import { useParams } from 'react-router-dom';
import E404 from '../error/e404';
import CategoryHeader from '../../containers/header/category-header';
import CategoryPostsList from '../../containers/posts-list/category-posts-list';
import MainLoading from '../../components/loading/main-loading';

function Category() {
  const { setCurrentRoute, deletedPostManager } = useContext(Context);
  const [provider] = useContext(PostsListContext);
  const { categoryId, uniqTitle } = useParams();

  useEffect(() => {
    setCurrentRoute('/category');

    provider.handleSetCategory(categoryId, uniqTitle);

    deletedPostManager.setPart('category');
  }, [categoryId]);

  if (provider.categoryLoaded === 'ok') {
    return (
      <React.Fragment>
        <CategoryHeader category={provider.category} />
        <CategoryPostsList />
      </React.Fragment>
    );
  } else {
    if (provider.categoryLoaded === 'loading') {
      return <MainLoading />;
    } else {
      return <E404 />;
    }
  }
}

export default Category;
